export interface PartnerProgressReview {
  reviewId: number
  durationOfDays: number
  progressStatus: ProgressStatus
  progressCompletedAt: string
  progressCount: number
  progresses: ProgressView[]
}

export interface ProgressView {
  id: number
  reviewId: number
  postedAt: string
  durationOfDays: number
  treatmentReceivedAt: string
  progressDate: string
  authorId: number
  authorCountry: string
  authorNickname: string
  description: string
  photos: Photo[]
  ratings: Rating[]
}

export interface Photo {
  url: string
  blurred: boolean
}

export interface Rating {
  questionnaireType: QuestionnaireType
  score: number
  content: string
}

export enum ProgressStatus {
  ONGOING = 'PROGRESS_ONGOING',
  COMPLETED = 'PROGRESS_COMPLETED',
}

export enum QuestionnaireType {
  PAIN_LEVEL = 'PAIN_LEVEL',
  SWELLING_LEVEL = 'SWELLING_LEVEL',
  CUT_LEVEL = 'CUT_LEVEL',
}
